
import { createRoot } from 'react-dom/client';

import Helper from "Interfaces/Helper";
import ComponentBackground from "GeneralComponents/ComponentBackground"
import TextHolderBox from "./TextHolderBox";
import useTextHolder from './useTextHolder';

import "./TextHolder.css";

interface Props {
    id: string;
    title: string;
    shortDescription: string;
    description: string;
    desktopImage: string;
    mobileImage: string;
    icon: string;
    backColor: string;
    changeImagePosition: boolean;
    linkBtn: string;
    componentType: string;
    backgroundImage: string;
    mobileBackgroundImage: string;
    shadowColor: string;
    showSmallImage: string;
    alignTextToRL: string;
    changeButtonPosition: string;
};



const TextHolder: React.FC<Props> = (props) => {

    const { id, componentType } = props;
    const { COMPONENT_TYPES, SHADOW_COLORS } = useTextHolder();

    const backGroundClass = "mst-customBgColor-" + id;
    const textColorClass = "";
    const dir = getComputedStyle(document.documentElement).direction;
    const backGround = props.backColor ? JSON.parse(props.backColor) : null;
    const linkBtn = Helper.convertServerLinkItemToClientLinkItem(props.linkBtn);

    const desktopImage = Helper.convertServerMediaItemToMediaItem(props.desktopImage);
    const mobileImage = Helper.convertServerMediaItemToMediaItem(props.mobileImage);
    const backgroundImage = Helper.convertServerMediaItemToMediaItem(props.backgroundImage);
    const mobileBackgroundImage = Helper.convertServerMediaItemToMediaItem(props.mobileBackgroundImage);

    const contentProps = {
        ...props,
        shadowColor: props.shadowColor || SHADOW_COLORS.Light,
        dir,
        backGroundClass,
        textColorClass,
        backGround,
        linkBtn,
        desktopImage,
        mobileImage,
    };

    const isTextHolderBGImg = componentType === COMPONENT_TYPES.BG;

    return (

        isTextHolderBGImg ?

            <ComponentBackground
                componentId={"TextHolder-" + id}
                bgImage={backgroundImage.url}
                bgMobileImage={mobileBackgroundImage.url}
                backGround={backGround}
                bgImgOpacity="Pallete"
                setLightBg={null}
                viewName={componentType}>

                <div className="mst-Text-Holder-With-Bg">

                    <TextHolderBox {...contentProps} />

                </div>

            </ComponentBackground>

            :

            <ComponentBackground
                componentId={"TextHolder-" + id}
                backGround={backGround}
                bgImgOpacity="Pallete"
                setLightBg={null}
                viewName={componentType}>

                <TextHolderBox {...contentProps} />

            </ComponentBackground>

    );

}


var elements = document.querySelectorAll('[id^="TextHolder-"]');


for (var i = 0; i < elements.length; i++) {


    var rootElement = document.getElementById(elements[i].id);
    var root = createRoot(rootElement);
    root.render(
        <TextHolder
            id={rootElement.getAttribute('component-id')}
            title={rootElement.getAttribute('component-title')}
            shortDescription={rootElement.getAttribute('component-shortDescription')}
            description={rootElement.getAttribute('component-description')}
            desktopImage={rootElement.getAttribute('component-desktopImage')}
            mobileImage={rootElement.getAttribute('component-mobileImage')}
            backgroundImage={rootElement.getAttribute('component-backgroundImage')}
            mobileBackgroundImage={rootElement.getAttribute('component-mobileBackgroundImage')}
            icon={rootElement.getAttribute('component-icon')}
            backColor={rootElement.getAttribute('component-backColor')}
            changeImagePosition={!!rootElement.getAttribute('component-changeImagePosition')}
            linkBtn={rootElement.getAttribute('component-buttonLink')}
            componentType={rootElement.getAttribute('component-type')}
            showSmallImage={rootElement.getAttribute('component-showSmallImage')}
            alignTextToRL={rootElement.getAttribute('component-alignTextToRL')}
            changeButtonPosition={rootElement.getAttribute('component-changeButtonPosition')}
            shadowColor={rootElement.getAttribute('component-shadowColor')}
            

        />);

}
